import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-perfil-crezcamos-encabezado',
  templateUrl: './perfil-crezcamos-encabezado.component.html',
  styleUrls: ['./perfil-crezcamos-encabezado.component.scss']
})
export class PerfilCrezcamosEncabezadoComponent { }
